import { render } from "./assessment-panel--grid-inactive.vue?vue&type=template&id=7c0e6fd7&scoped=true&ts=true"
import script from "./assessment-panel--grid-inactive.vue?vue&type=script&lang=ts"
export * from "./assessment-panel--grid-inactive.vue?vue&type=script&lang=ts"

import "./assessment-panel--grid-inactive.vue?vue&type=style&index=0&id=7c0e6fd7&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0e6fd7"]])

export default __exports__